module.exports = __webpack_public_path__ + "img/defaultAvatar.812c81f3.png";